import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DetailDataOrderModel } from 'src/app/models/detail-data-order.model';
import { awbHistoryModel } from 'src/app/models/awb-history.model';

@Component({
  standalone: false,
  selector: 'app-shipping-info-default',
  templateUrl: './shipping-info-default.component.html',
})
export class ShippingInfoDefaultComponent {
  @Input() detailOrder!: DetailDataOrderModel;
  @Input() loading: boolean = true;
  @Input() awbHistory: awbHistoryModel[] = [];
  @Output() openTrackReceipt = new EventEmitter<'nodata' | 'data'>();

  handleType(shippingType: string): string {
    if (shippingType === 'SAPFlat') {
      return 'Flat';
    } else if (shippingType === 'JNEFlat') {
      return 'Flat';
    } else if (shippingType === 'Instant') {
      return 'Instant';
    } else {
      return '';
    }
  }

  onTrackReceipt(): void {
    if (this.awbHistory.length === 0) {
      this.openTrackReceipt.emit('nodata');
    } else {
      this.openTrackReceipt.emit('data');
    }
  }
}
